export type UserRole = 'user' | 'agency' | 'admin';

export interface AuthUser {
  id?: string;
  phoneNumber?: string;
  firstName?: string;
  lastName?: string;
  role?: UserRole;
}

export function getRoleFromToken(token: string | null): UserRole {
  if (!token) return 'user';
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const role = payload.role as UserRole;
    if (role === 'admin' || role === 'agency') return role;
    return 'user';
  } catch {
    return 'user';
  }
}
